import moment from 'moment'

export function paramsToMomentUtc({ year, month = '1', day = '15' }) {
  return moment.utc({ year: parseInt(year), month: parseInt(month) - 1, date: parseInt(day) })
}
